<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.3749 2.625C10.3749 2.27982 10.0951 2 9.7499 2C9.40473 2 9.1249 2.27982 9.1249 2.625V9.37442H2.375C2.02982 9.37442 1.75 9.65424 1.75 9.99942C1.75 10.3446 2.02982 10.6244 2.375 10.6244H9.1249V17.3745C9.1249 17.7197 9.40473 17.9995 9.7499 17.9995C10.0951 17.9995 10.3749 17.7197 10.3749 17.3745V10.6244H17.1245C17.4697 10.6244 17.7495 10.3446 17.7495 9.99942C17.7495 9.65424 17.4697 9.37442 17.1245 9.37442H10.3749V2.625Z" />
</template>
